var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSchemeOutline = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "scheme_outline") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Assets",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Artboard",
  transform: "translate(-695.000000, -288.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "scheme_outline",
  transform: "translate(695.000000, 288.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-5",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("path", {
  d: "M10,2 C8.89,2 8,2.89 8,4 L8,7 C8,8.11 8.89,9 10,9 L11,9 L11,11 L2,11 L2,13 L6,13 L6,15 L5,15 C3.89,15 3,15.89 3,17 L3,20 C3,21.11 3.89,22 5,22 L9,22 C10.11,22 11,21.11 11,20 L11,17 C11,15.89 10.11,15 9,15 L8,15 L8,13 L16,13 L16,15 L15,15 C13.89,15 13,15.89 13,17 L13,20 C13,21.11 13.89,22 15,22 L19,22 C20.11,22 21,21.11 21,20 L21,17 C21,15.89 20.11,15 19,15 L18,15 L18,13 L22,13 L22,11 L13,11 L13,9 L14,9 C15.11,9 16,8.11 16,7 L16,4 C16,2.89 15.11,2 14,2 L10,2 M10,4 L14,4 L14,7 L10,7 L10,4 M5,17 L9,17 L9,20 L5,20 L5,17 M15,17 L19,17 L19,20 L15,20 L15,17 Z",
  id: "Shape",
  fill: "#757575",
  fillRule: "nonzero"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSchemeOutline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/scheme_outline.3dd5ce68fcabbaed9f8e276b642453a4.svg";